
















































import '@/assets/scss/pages/page-auth.scss';
import UserStatusBadge from '@/components/common/UserStatusBadge.vue';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';

import AButton from '@/components/common/AButton.vue';
import Avatar from '@/components/common/Avatar.vue';
import AdmiralCheckbox from '@/components/common/selects/AdmiralCheckbox.vue';
import { PermissionMixin } from '@/mixins/PermissionMixin';
import { CheckIcon, Edit2Icon, FileTextIcon, InfoIcon, MoreVerticalIcon } from 'vue-feather-icons';
import { FlixcheckApi } from '@/services/integrations/FlixcheckApi';
import FormError from '@/components/common/forms/FormError.vue';
import { MakeComApi } from '@/services/integrations/MakeComApi';

@Component({
  name: 'make-com-webhook-settings',
  components: {
    AdmiralCheckbox,
    Avatar,
    UserStatusBadge,
    MoreVerticalIcon,
    Edit2Icon,
    CheckIcon,
    AButton,
    InfoIcon,
    FileTextIcon,
    FormError,
  },
})
class MakeComWebhookSettings extends mixins(BaseMixin, PermissionMixin) {
  webhookUrl = '';
  apiKey = '';
  isLoading = false;
  errors: Record<string, string[]> = {};

  async mounted() {
    await this.loadWebhook();
  }

  async saveWebhook() {
    this.isLoading = true;
    this.errors = {};
    try {
      const response = await MakeComApi.saveWebhook(this.webhookUrl, this.apiKey);
      await this.loadWebhook();
    } catch (error) {
      this.errors = {
        general: [
          'Etwas ist schiefgelaufen. Bitte überprüfe deine Eingaben und versuche es erneut.',
        ],
      };
    } finally {
      this.isLoading = false;
    }
  }

  async loadWebhook() {
    try {
      const response = await MakeComApi.getWebhook();
      this.webhookUrl = response.data.webhookUrl;
      this.apiKey = response.data.apiKey;
    } catch (error) {
      this.webhookUrl = '';
      this.apiKey = '';
    }
  }
}

export default MakeComWebhookSettings;
